import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-primary-button-loader',
  templateUrl: './primary-button-loader.component.html',
  styleUrls: ['./primary-button-loader.component.scss']
})
export class PrimaryButtonLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
